export type MediaType = 'movie' | 'tv' | 'variety';

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  poster: string;
  backdrop: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  director: string;
  cast: string[];
  synopsis: string;
  popularity: number;
  episodes: string;
  tagline: string;
}

export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  category: string;
  date: string;
  cover: string;
  author: string;
  relatedId?: string;
}

export const MEDIA_TYPE_LABEL: Record<MediaType, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};